import { DISCOVER_PATH, TOOLS_PATH } from '@/common/constants/routes';
import Link from 'next/link';
import { Button } from '@/components/Button/Button';
import {
  ButtonGroup,
  Header,
  StyledLink,
  Text,
  Wrapper,
} from './WhatIsOVSection.styles';

export function WhatIsOVSection(): JSX.Element {
  function openLiveChat() {
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    Intercom('show');
  }

  return (
    <Wrapper elevation={0}>
      <Header>What is OneVillage?</Header>
      <Text>
        Overcome Life Challenges with the help of the OneVillage community.
        Whether you're facing difficult conditions like major surgery,
        depression or other obstacles, OneVillage is here for you. Discover{' '}
        <Link href="/discover?filters=resource" passHref>
          <StyledLink>relatable content</StyledLink>
        </Link>
        ,{' '}
        <Link href={TOOLS_PATH} passHref>
          <StyledLink>care planning tools</StyledLink>
        </Link>
        , and{' '}
        <Link href={DISCOVER_PATH} passHref>
          <StyledLink>community groups</StyledLink>
        </Link>{' '}
        filled with valuable advice from people who understand. Whether you're
        seeking to learn from others' experiences, find support as a caregiver,
        or access medically approved resources, OneVillage is your go-to
        platform.
      </Text>
      <Text>Want to learn more about how it works?</Text>
      <ButtonGroup>
        <Button onClick={openLiveChat}>Live Chat</Button>
        <Link href="/contact-us" passHref>
          <Button variant="outlined">Contact Us</Button>
        </Link>
      </ButtonGroup>
    </Wrapper>
  );
}
